"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _propTypes = require("../prop-types");

var _utils = require("../utils");

var ViewBasePropTypes = (0, _objectSpread2.default)({}, _propTypes.displayPropTypes, _propTypes.colorPropTypes, _propTypes.backgroundColorPropTypes, _propTypes.borderPropTypes, _propTypes.flexAttributesPropTypes, _propTypes.widthWithMinMaxPropTypes, _propTypes.heightWithMinMaxPropTypes, _propTypes.spacingPropTypes);
var ViewBase = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(ViewBasePropTypes, {
    filterInvalidHTML: true,
    additionalPropsToFilter: ['overflow']
  })
})(function (_ref) {
  var theme = _ref.theme,
      props = (0, _objectWithoutProperties2.default)(_ref, ["theme"]);
  var selectors = theme.selectors;
  var baseStyles = {
    margin: 0
  };

  if (props.border && props.border.length > 0) {
    if (props.border.match(/^\d/)) {
      var _props$border$split = props.border.split(' '),
          _props$border$split2 = (0, _slicedToArray2.default)(_props$border$split, 3),
          borderWidth = _props$border$split2[0],
          borderStyle = _props$border$split2[1],
          borderColor = _props$border$split2[2];

      baseStyles.border = "".concat(borderWidth, " ").concat(borderStyle || 'solid').concat(borderColor ? " ".concat(selectors.colorOrNull(borderColor) || borderColor) : '');
    } else {
      var _props$border$split3 = props.border.split(' '),
          _props$border$split4 = (0, _slicedToArray2.default)(_props$border$split3, 2),
          _borderStyle = _props$border$split4[0],
          _borderColor = _props$border$split4[1];

      baseStyles.border = "".concat(_borderStyle).concat(_borderColor ? " ".concat(selectors.colorOrNull(_borderColor) || _borderColor) : '');
    }
  }

  return (0, _objectSpread2.default)({}, baseStyles, (0, _utils.cssValueProp)(selectors.colorOrNull, props.color, 'color'), (0, _utils.cssValueProp)(selectors.colorOrNull, props.backgroundColor, 'backgroundColor'), (0, _utils.getPropsStyles)(['flex', 'justifyContent', 'alignItems', 'flexDirection', 'flexWrap', 'alignSelf', 'overflow', 'display'], props), (0, _utils.getSpacingStyles)(['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'margin', 'padding'], props, selectors.space));
});
var ViewBaseWithDocs = (0, _stencilReactDesc.describe)(ViewBase).description('The most basic layout element which other components are built on top of.');
ViewBaseWithDocs.propTypes = (0, _objectSpread2.default)({}, ViewBasePropTypes, {
  children: _stencilReactDesc.PropTypes.node.description('Elements to display within the View.'),
  overflow: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'overflow' property on the element.")
});
var View = (0, _utils.withTestAttributes)({
  component: 'StencilReactView'
})(ViewBaseWithDocs);
View.displayName = 'View';
var _default = View;
exports.default = _default;